import React, { useMemo, useState } from "react";
import "./AdminShortcuts.css";
import { apiFetch } from "../components/api";

export default function AdminShortcuts() {
  const [base, setBase] = useState("");
  const [query, setQuery] = useState("");
  const [projectName, setProjectName] = useState("");
  const [productId, setProductId] = useState("");
  // 카드별 현재 선택된 HTTP 메소드 보관
  const [methodSel, setMethodSel] = useState({}); // key: `${group}:${label}` -> "GET" | ...

  const routes = useMemo(() => ([
    // ===== Models (CRUD 전부 허용) =====
    {
      group: "Models",
      label: "Major Categories",
      path: "api/database/major-categories/",
      methods: ["GET","POST","PUT","PATCH","DELETE"],
      swagger: "api/api_database_major_categories_list"
    },
    {
      group: "Models",
      label: "Sub Categories",
      path: "api/database/sub-categories/",
      methods: ["GET","POST","PUT","PATCH","DELETE"],
      swagger: "api/api_database_sub_categories_list"
    },
    {
      group: "Models",
      label: "Major Locations",
      path: "api/database/major-locations/",
      methods: ["GET","POST","PUT","PATCH","DELETE"],
      swagger: "api/api_database_major_locations_list"
    },
    {
      group: "Models",
      label: "Mid Locations",
      path: "api/database/mid-locations/",
      methods: ["GET","POST","PUT","PATCH","DELETE"],
      swagger: "api/api_database_mid_locations_list"
    },
    {
      group: "Models",
      label: "Sub Locations",
      path: "api/database/sub-locations/",
      methods: ["GET","POST","PUT","PATCH","DELETE"],
      swagger: "api/api_database_sub_locations_list"
    },
    {
      group: "Models",
      label: "Major Packages",
      path: "api/database/major-packages/",
      methods: ["GET","POST","PUT","PATCH","DELETE"],
      swagger: "api/api_database_major_packages_list"
    },
    {
      group: "Models",
      label: "Sub Packages",
      path: "api/database/sub-packages/",
      methods: ["GET","POST","PUT","PATCH","DELETE"],
      swagger: "api/api_database_sub_packages_list"
    },
    {
      group: "Models",
      label: "Inventory States",
      path: "api/database/inventory-states/",
      methods: ["GET","POST","PUT","PATCH","DELETE"],
      swagger: "api/api_database_inventory_states_list"
    },

    // ===== Database =====
    { group: "Database", label: "DB Tools", path: "admin/database/", method: "GET" },
    // { group: "Database", label: "DB Dump", path: "admin/database/dump", method: "GET" },
    // { group: "Database", label: "DB Restore", path: "admin/database/restore/", method: "POST" },

    // ===== Uploads =====
    { group: "Uploads", label: "Upload Categories", path: "admin/database/upload/categories/", method: "POST" },
    { group: "Uploads", label: "Upload Locations", path: "admin/database/upload/locations/", method: "POST" },
    { group: "Uploads", label: "Upload Packages", path: "admin/database/upload/packages/", method: "POST" },
    { group: "Uploads", label: "Upload Inventory State", path: "admin/database/upload/inventory-state/", method: "POST" },
    { group: "Uploads", label: "Upload Suppliers", path: "admin/database/upload/suppliers/", method: "POST" },
    { group: "Uploads", label: "Upload Products", path: "admin/database/upload/products/", method: "POST" },
    // { group: "Uploads", label: "Upload BOM", path: "admin/database/upload/bom/", method: "POST" },

    // ===== Downloads =====
    { group: "Downloads", label: "Download Products", path: "admin/database/download/products/", method: "GET" },
    // { group: "Downloads", label: "Download BOM (:project_name)", path: () => `download-bom/${encodeURIComponent(projectName || "<project>")}/`, method: "GET", needs: "project_name" },

    // ===== Inventory =====
    { group: "Inventory", label: "Inventory List", path: "api/inventory/", method: "GET" },
    // { group: "Inventory", label: "Update Stock (:pk)", path: () => `api/inventory/update/${Number(productId || 0) || 0}/stock/`, method: "POST", needs: "pk" },
    // { group: "Inventory", label: "Update Location", path: () => `api/inventory/update/${Number(productId || 0) || 0}/location/`, method: "POST", needs: "pk" },
    // { group: "Inventory", label: "Update State", path: () => `api/inventory/update/${Number(productId || 0) || 0}/state/`, method: "POST", needs: "pk" },
    // { group: "Inventory", label: "Split Inventory", path: "api/inventory/update-split/", method: "POST" },
    // { group: "Inventory", label: "Product Logs (:product_id)", path: () => `api/inventory/logs/${Number(productId || 0) || 0}/`, method: "GET", needs: "product_id" },
    // { group: "Inventory", label: "Product Temp Move (:product_id)", path: () => `api/inventory/temp-move/${Number(productId || 0) || 0}/`, method: "POST", needs: "product_id" },
    { group: "Inventory", label: "Location Barcode", path: "api/inventory/barcode/", method: "GET" },

    // ===== StockIn =====  // ===== Product =====
    // { group: "Product", label: "Product Detail (:product_id)", path: () => `product/${Number(productId || 0) || 0}/`, method: "GET", needs: "product_id" },
    // { group: "Product", label: "Product Lookup", path: "api/product/lookup/", method: "GET" },
    { group: "Product", label: "Product Barcode", path: "api/product/barcode/", method: "GET" },

    // { group: "StockIn", label: "StockIn Init", path: "api/product/quick-list/", method: "GET" },
    // { group: "StockIn", label: "StockIn By Major (:major_id)", path: () => `api/product/by-major/${Number(productId || 0) || 0}/`, method: "GET", needs: "product_id" }, // 숫자 인풋 재사용
    // { group: "StockIn", label: "StockIn Quick Create", path: "api/product/create/", method: "POST" },
    // { group: "StockIn", label: "StockIn Suppliers", path: "api/product/suppliers/", method: "GET" },
    // { group: "StockIn", label: "StockIn Purchase", path: "api/product/purchase/", method: "POST" },
    

    // ===== Analytics =====
    { group: "Dashboard", label: "Category Distribution", path: "api/dashboard/category-distribution/", method: "GET" },
    { group: "Dashboard", label: "PCB Distribution", path: "api/dashboard/pcb-models/", method: "GET" },
    { group: "Dashboard", label: "Low Stock Alert", path: "api/dashboard/low-stock/", method: "GET" },
    { group: "Dashboard", label: "Monthly Flow", path: "api/dashboard/monthly-flow/", method: "GET" },
    { group: "Dashboard", label: "Event", path: "api/inventory/logs/", method: "GET" },

    // ===== Print =====
    // { group: "Print", label: "Print Label", path: "api/print/label/", method: "POST" },
    // { group: "Print", label: "Label Profile Test", path: "api/print/label/profile", method: "GET" },
    // { group: "Print", label: "Label Render", path: "api/print/label/render", method: "GET" },
    { group: "Print", label: "Label Profiles", path: "api/print/profile/list", method: "GET" },
    { group: "Print", label: "defualt Profile", path: "api/print/profile/default", method: "GET" },
    // { group: "Print", label: "Profile Upsert", path: "api/print/profile/upsert", method: "POST" },
    // { group: "Print", label: "Profile Select", path: "api/print/profile/select", method: "POST" },
    { group: "Print", label: "Printer Health", path: "api/print/health/", method: "GET" },
  ]), [projectName, productId]);

  const isApiPath = (p) => {
    const s = String(p || "");
    return s.startsWith("/api/") || s.startsWith("api/");
  };

  const escapeHtml = (s) =>
    String(s)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;");

  const openTextInNewTab = (title, text) => {
    const w = window.open("", "_blank");
    if (!w) return;
    w.document.title = title || "API Result";
    w.document.write(
      `<pre style="white-space:pre-wrap;word-break:break-word;">${escapeHtml(text)}</pre>`
    );
    w.document.close();
  };

  const openApiByApiFetch = async (r, selMethod) => {
    const method =
      selMethod ||
      r.method ||
      (Array.isArray(r.methods) ? r.methods[0] : "GET") ||
      "GET";

    const path = absoluteUrl(r);
    const needsBody = !["GET", "DELETE"].includes(method);

    const data = await apiFetch(path, {
      method,
      ...(needsBody ? { body: {} } : {}),
    });

    const text =
      typeof data === "string" ? data : JSON.stringify(data, null, 2);

    openTextInNewTab(`${method} ${toPath(r)}`, text);
  };

  const isDatabasePath = (p) => {
    const s = String(p || "");
    return s.startsWith("/api/database/") || s.startsWith("api/database/");
  };

  const openDatabaseInSwagger = (r) => {
    const path = toPath(r);
    if (!r.swagger) {
      alert("swagger 해시가 없습니다.");
      return;
    }
    const url = `${window.location.origin}/api/schema/swagger-ui/#/${r.swagger}`;
    window.open(url, "_blank");
    // copy(path);
    copyAccessToken();
  };

  const groups = useMemo(() => {
    const by = new Map();
    for (const r of routes) {
      if (query && !(`${r.group} ${r.label}`.toLowerCase().includes(query.toLowerCase()))) continue;
      if (!by.has(r.group)) by.set(r.group, []);
      by.get(r.group).push(r);
    }
    return Array.from(by.entries());
  }, [routes, query]);

  const copy = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      alert("URL을 복사완료.");
    } catch (e) {
      console.error(e);
      alert("복사 실패.");
    }
  };

  const copyCurl = async (r, selMethod) => {
    const url = absoluteUrl(r);
    const method = selMethod || effectiveMethod(r, `${r.group}:${r.label}`);
    const needsBody = !["GET", "DELETE"].includes(method);
    const token = localStorage.getItem("authToken");

    const authPart = isApiPath(toPath(r)) && token
      ? ` -H "Authorization: Bearer ${token}"`
      : "";

    const bodyPart = needsBody ? ` -H "Content-Type: application/json" -d "{}"` : "";
    const curl = `curl -X ${method} "${url}"${authPart}${bodyPart}`;
    copy(curl);
  };

  const toPath = (r) => {
    const p = typeof r.path === "function" ? r.path() : r.path;
    if (!p) return "/";
    return p.startsWith("/") ? p : `/${p}`;
  };

  const effectiveMethod = (r, key) => {
    const picked = methodSel[key];
    if (picked) return picked;
    if (r.method) return r.method;
    if (Array.isArray(r.methods) && r.methods.length) return r.methods[0];
    return "GET";
  };

  const absoluteUrl = (r) => {
    const path = toPath(r);

    // base가 비어있으면 그대로 사용(현재 도메인 기준)
    if (!base) return path;

    // base가 "https://..." 같은 절대 URL이면 그걸 우선
    if (/^https?:\/\//i.test(base)) {
      return `${base.replace(/\/+$/, "")}${path}`;
    }

    // base가 "/something" 같은 경로면 origin + base + path
    const b = base.startsWith("/") ? base : `/${base}`;
    return `${window.location.origin}${b.replace(/\/+$/, "")}${path}`;
  };

  const fullUrl = (r) => absoluteUrl(r);

  const copyAccessToken = async () => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      alert("토큰이 없습니다. 먼저 로그인하세요.");
      return;
    }
    await navigator.clipboard.writeText(token); // Bearer 없이
    // alert("토큰이 복사되었습니다.");
  };

  return (
    <div className="as-root">
      <div className="as-wrap">
        <header className="as-header">
          <div>
            <h1 className="as-title">⚡ 관리자 빠른 접근</h1>
            <p className="as-sub">자주 쓰는 관리 URL을 한 화면에서 열기 / 복사 / cURL</p>
          </div>
          <div className="as-base">
            {/* <label className="as-label">Base path</label>
            <input
              value={base}
              onChange={(e) => setBase(e.target.value)}
              className="as-input"
              placeholder="/api/"
            /> */}
            <div className="as-field">
              <button className="as-btn" onClick={copyAccessToken}>
                Copy Token
              </button>
            </div>
          </div>
        </header>

        {/* <section className="as-controls">
          <div className="as-field">
            <label className="as-label">Search</label>
            <input
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              className="as-input"
              placeholder="upload, db, inventory ..."
            />
          </div>
          <div className="as-grid2">
            <div className="as-field">
              <label className="as-label">:project_name</label>
              <input
                value={projectName}
                onChange={(e) => setProjectName(e.target.value)}
                className="as-input"
                placeholder="e.g. HY-Board-A"
              />
            </div>
            <div className="as-field">
              <label className="as-label">:product_id / :pk</label>
              <input
                value={productId}
                onChange={(e) => setProductId(e.target.value.replace(/[^0-9]/g, ""))}
                className="as-input"
                placeholder="e.g. 123"
              />
            </div>
          </div>
        </section> */}

        <main className="as-main">
          {groups.map(([groupName, items]) => (
            <section key={groupName} className="as-section">
              <div className="as-section-head">
                <h2 className="as-section-title">{groupName}</h2>
                <span className="as-badge">{items.length} link(s)</span>
              </div>
              <div className="as-cards">
                {items.map((r, idx) => {
                  const url = fullUrl(r);
                  const needsParam = r.needs && ((r.needs === "project_name" && !projectName) || (r.needs === "product_id" && !productId) || (r.needs === "pk" && !productId));
                  const key = `${r.group}:${r.label}`;
                  const selMethod = effectiveMethod(r, key);
                  const isArray = Array.isArray(r.methods);
                  // const openDisabled = needsParam || selMethod !== "GET";
                  const openDisabled = needsParam;
                  return (
                    <article key={idx} className="as-card">
                      <div className="as-card-head">
                        <h3 className="as-card-title">{r.label}</h3>
                        {isArray ? (
                          <select
                            className="as-chip as-select"
                            value={selMethod}
                            onChange={(e) => setMethodSel((prev) => ({ ...prev, [key]: e.target.value }))}
                            title="HTTP Method 선택"
                          >
                            {r.methods.map((m) => <option key={m} value={m}>{m}</option>)}
                          </select>
                        ) : (
                          <span className="as-chip">{r.method}</span>
                        )}
                      </div>

                      <code className="as-code">{url}</code>
                      {needsParam && (
                        <p className="as-warn">필수 파라미터 필요.</p>
                      )}

                      <div className="as-actions">
                        <button
                          className="as-btn"
                          onClick={() => {
                            const p = toPath(r);

                            if (isDatabasePath(p)) {
                              openDatabaseInSwagger(r);
                              return;
                            }

                            if (isApiPath(p)) {
                              openApiByApiFetch(r, selMethod);
                              return;
                            }

                            window.open(absoluteUrl(r), "_blank");
                          }}
                          disabled={openDisabled}
                        >
                          Open
                        </button>

                        <button
                          className="as-btn"
                          onClick={() => copy(absoluteUrl(r))}
                          title="URL 복사"
                        >Copy URL</button>

                        <button
                          className="as-btn"
                          onClick={() => copyCurl(r, selMethod)}
                          title="cURL 복사"
                        >Copy cURL</button>
                      </div>
                    </article>
                  );
                })}
              </div>
            </section>
          ))}
        </main>

        <footer className="as-foot">
          Admin shortcuts · base: {base}
        </footer>
      </div>
    </div>
  );
}
